import { Document, Page, StyleSheet, Text, View } from '@react-pdf/renderer'
import { createTw } from 'react-pdf-tailwind'
import { WorkingAbroadUserType } from './TendenciesNumericInfo'
import { Fragment } from 'react/jsx-runtime'
import { splitArrayIntoChunks } from '../../../helpers/utils'

const color = '#CEDBED'

const tw = createTw({
    theme: {
        fontFamily: {
            sans: ['Comic Sans'],
        },
        extend: {
            colors: {
                custom: '#bada55',
            },
        },
    },
})

const rowStyle = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: color,
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        fontStyle: 'bold',
    },
    name: {
        width: '26%',
        textAlign: 'left',
        borderRightColor: color,
        borderRightWidth: 1,
        paddingLeft: '8px',
    },
    email: {
        width: '36%',
        borderRightColor: color,
        borderRightWidth: 1,
        textAlign: 'left',
        paddingLeft: '8px',
    },
    country: {
        width: '18%',
        borderRightColor: color,
        borderRightWidth: 1,
        textAlign: 'left',
        paddingLeft: '8px',
    },
    company: {
        width: '20%',
        textAlign: 'left',
        paddingLeft: '8px',
    },
})

const TableRow = ({ data, showPhone }: { data: WorkingAbroadUserType[]; showPhone: boolean }) => {
    const rows = data.map((user) => (
        <View
            style={rowStyle.row}
            key={user.email}
        >
            <Text style={rowStyle.name}>{user.firstName + ' ' + user.lastName}</Text>
            <Text style={rowStyle.email}>{user.email}</Text>
            <Text style={rowStyle.country}>{user.country.split(/(?=[A-Z])/).join(' ')}</Text>
            <Text style={rowStyle.company}>{showPhone ? user.phone : user.currentEmployer}</Text>
        </View>
    ))
    return <Fragment>{rows}</Fragment>
}

const headerStyle = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: color,
        backgroundColor: color,
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        textAlign: 'center',
        fontStyle: 'bold',
        flexGrow: 1,
    },
    name: {
        width: '26%',
        borderRightColor: color,
        borderRightWidth: 1,
    },
    email: {
        width: '36%',
        borderRightColor: color,
        borderRightWidth: 1,
    },
    country: {
        width: '18%',
        borderRightColor: color,
        borderRightWidth: 1,
    },
    company: {
        width: '20%',
    },
})

const TableHeader = ({ showPhone }: { showPhone: boolean }) => (
    <View style={headerStyle.container}>
        <Text style={headerStyle.name}>Nombre</Text>
        <Text style={headerStyle.email}>Email</Text>
        <Text style={headerStyle.country}>País donde trabaja</Text>
        <Text style={headerStyle.company}>{showPhone ? 'Teléfono' : 'Empresa'}</Text>
    </View>
)

const itemsStyle = StyleSheet.create({
    tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        borderWidth: 1,
        borderColor: color,
        marginTop: '-10px',
    },
})

const PDFTable = ({
    data,
    showPhone = false,
}: {
    data: WorkingAbroadUserType[]
    showPhone?: boolean
}) => (
    <View style={itemsStyle.tableContainer}>
        <TableHeader showPhone={showPhone} />
        <TableRow
            data={data}
            showPhone={showPhone}
        />
    </View>
)

interface Props {
    abroadUsers: WorkingAbroadUserType[]
    freelanceUsers: WorkingAbroadUserType[]
    entrepeneurUsers: WorkingAbroadUserType[]
}
const TendenciesNumericInfoPDF = ({ abroadUsers, freelanceUsers, entrepeneurUsers }: Props) => {
    return (
        <Document>
            <Page size={'A4'}>
                <View style={tw('flex flex-col px-4 w-full text-sm')}>
                    <Text style={tw('text-3xl pt-5 text-[#333752] underline text-center')}>
                        Graduados que trabajan en el exterior
                    </Text>
                    {splitArrayIntoChunks(abroadUsers, 30).map((data, index) => (
                        <View
                            break={index > 0}
                            style={index > 0 ? tw('pt-12') : {}}
                        >
                            <PDFTable data={data} />
                        </View>
                    ))}
                </View>
                <View
                    break
                    style={tw('flex flex-col px-4 w-full text-sm')}
                >
                    <Text style={tw('text-3xl pt-5 text-[#333752] underline text-center')}>
                        Graduados emprendedores
                    </Text>
                    {splitArrayIntoChunks(entrepeneurUsers, 30).map((data, index) => (
                        <View
                            break={index > 0}
                            style={index > 0 ? tw('pt-12') : {}}
                        >
                            <PDFTable
                                data={data}
                                showPhone
                            />
                        </View>
                    ))}
                </View>
                <View
                    break
                    style={tw('flex flex-col px-4 w-full text-sm')}
                >
                    <Text style={tw('text-3xl pt-5 text-[#333752] underline text-center')}>
                        Graduados freelancers
                    </Text>
                    {splitArrayIntoChunks(freelanceUsers, 30).map((data, index) => (
                        <View
                            break={index > 0}
                            style={index > 0 ? tw('pt-12') : {}}
                        >
                            <PDFTable
                                data={data}
                                showPhone
                            />
                        </View>
                    ))}
                </View>
            </Page>
        </Document>
    )
}

export default TendenciesNumericInfoPDF
